import { render, staticRenderFns } from "./ProductTagList.vue?vue&type=template&id=f719da72&scoped=true&"
import script from "./ProductTagList.vue?vue&type=script&lang=js&"
export * from "./ProductTagList.vue?vue&type=script&lang=js&"
import style0 from "./ProductTagList.vue?vue&type=style&index=0&id=f719da72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f719da72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f719da72')) {
      api.createRecord('f719da72', component.options)
    } else {
      api.reload('f719da72', component.options)
    }
    module.hot.accept("./ProductTagList.vue?vue&type=template&id=f719da72&scoped=true&", function () {
      api.rerender('f719da72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/ProductTagList.vue"
export default component.exports